import React, { useEffect, useState } from 'react';
import { getNegocioId } from '../services/negocioActual';
import { linkProductoOG, linkWhatsAppA, compartirFacebook, copiarTexto } from '../utils/compartir';
import { textoProducto, archivoFoto, puedeCompartirArchivo, urlFotoParaCompartir } from '../utils/compartirProducto';
import { obtenerFotoPrincipal } from '../utils/categorias';
import { optimizarFoto } from '../utils/imagen';
import { useToast } from '../context/ToastContext';

// Compartir un producto desde el inventario: con la foto y el precio.
// - Celular: el menú del teléfono (WhatsApp, Instagram, Facebook…) con la FOTO.
// - A una clienta: WhatsApp a su número con el enlace (la vista previa trae la foto).
// - Facebook, copiar enlace y descargar la foto (para Instagram en la computadora).

const ROSA = 'var(--color-primario,#DB2777)';
const opcion = { display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 14px', borderRadius: '12px', border: '1px solid #ECE8F6', background: '#fff', fontSize: '15px', fontWeight: 600, cursor: 'pointer', textAlign: 'left', color: '#1C1830', fontFamily: 'inherit' };

export default function CompartirProductoModal({ producto, onCerrar }) {
  const { mostrarToast } = useToast();
  const [archivo, setArchivo] = useState(null);
  const [cargandoFoto, setCargandoFoto] = useState(true);
  const [telefono, setTelefono] = useState('');
  const link = linkProductoOG({ negocioId: getNegocioId(), productoId: producto.id });
  const texto = textoProducto(producto, link);
  const foto = obtenerFotoPrincipal(producto);

  // La foto se prepara al abrir: el menú del celular necesita abrirse en el mismo toque.
  useEffect(() => {
    let activo = true;
    Promise.resolve().then(() => archivoFoto(producto)).catch(() => null)
      .then((f) => { if (activo) { setArchivo(f || null); setCargandoFoto(false); } });
    return () => { activo = false; };
  }, [producto]);

  const conFoto = puedeCompartirArchivo(archivo);

  const compartirCelular = async () => {
    try {
      if (conFoto) await navigator.share({ files: [archivo], text: texto });
      else await navigator.share({ title: producto.nombre, text: textoProducto(producto), url: link });
    } catch (e) {
      if (e?.name !== 'AbortError') mostrarToast('No se pudo abrir el menú de compartir. Usa otra opción.', 'error');
    }
  };

  const aClienta = () => {
    const tel = telefono.replace(/\D/g, '');
    // El enlace va etiquetado "whatsapp": si pide, en Pedidos sale que llegó por WhatsApp.
    const textoWa = textoProducto(producto, linkProductoOG({ negocioId: getNegocioId(), productoId: producto.id, origen: 'whatsapp' }));
    const url = tel.length >= 8 ? linkWhatsAppA(telefono, `¡Hola! 😊 Te comparto esta pieza:\n${textoWa}`) : `https://api.whatsapp.com/send?text=${encodeURIComponent(textoWa)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const copiar = async () => {
    const ok = await copiarTexto(texto);
    mostrarToast(ok ? 'Copiado 📋 Pégalo donde quieras' : 'No se pudo copiar', ok ? 'exito' : 'error');
  };

  const descargar = async () => {
    const f = archivo || await archivoFoto(producto);
    if (!f) { window.open(urlFotoParaCompartir(producto), '_blank', 'noopener,noreferrer'); return; }
    const a = document.createElement('a');
    a.href = URL.createObjectURL(f); a.download = f.name;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    mostrarToast('Foto descargada ⬇️ Súbela a tu historia o mándala por mensaje', 'exito', 5000);
  };

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, background: 'rgba(20,10,30,.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-label={`Compartir ${producto.nombre}`}
        style={{ background: '#fff', borderRadius: '20px', width: '100%', maxWidth: '400px', maxHeight: '92vh', overflowY: 'auto', padding: '20px', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <b style={{ fontSize: '17px' }}>📤 Compartir producto</b>
          <button onClick={onCerrar} aria-label="Cerrar" style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', background: '#FBFAFE', border: '1px solid #F1EEF8', borderRadius: '14px', padding: '10px', marginBottom: '14px' }}>
          {foto ? <img src={optimizarFoto(foto, 200)} alt="" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '10px', flex: '0 0 auto' }} /> : <span style={{ fontSize: '36px' }}>📦</span>}
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '13px', color: '#374151', minWidth: 0 }}>{textoProducto(producto)}</pre>
        </div>

        <div style={{ display: 'grid', gap: '8px' }}>
          {typeof navigator !== 'undefined' && navigator.share && (
            <button style={{ ...opcion, background: ROSA, color: '#fff', border: 'none' }} disabled={cargandoFoto} onClick={compartirCelular}>
              <span style={{ fontSize: '20px' }}>📱</span>
              <span>{cargandoFoto ? 'Preparando la foto…' : conFoto ? 'Compartir con la foto' : 'Compartir'}<br />
                <small style={{ fontWeight: 400, opacity: 0.9 }}>WhatsApp, Instagram, Facebook y más</small></span>
            </button>
          )}

          <div style={{ ...opcion, display: 'block', cursor: 'default' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}><span style={{ fontSize: '20px' }}>💬</span> Enviar a una clienta por WhatsApp</div>
            <div style={{ display: 'flex', gap: '6px' }}>
              <input className="k-input" inputMode="tel" placeholder="Su número (opcional)" value={telefono} onChange={(e) => setTelefono(e.target.value)} aria-label="Número de WhatsApp de la clienta" style={{ flex: 1, minWidth: 0 }} />
              <button onClick={aClienta} style={{ padding: '0 16px', borderRadius: '10px', border: 'none', background: '#25D366', color: '#fff', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Enviar</button>
            </div>
            <small style={{ display: 'block', marginTop: '6px', color: '#6B7280', fontWeight: 400 }}>Sin número, eliges el chat en WhatsApp. El mensaje lleva el enlace con la foto del producto.</small>
          </div>

          <button style={opcion} onClick={() => compartirFacebook(link)}><span style={{ fontSize: '20px' }}>👍</span> Publicar en Facebook</button>
          <button style={opcion} onClick={descargar}><span style={{ fontSize: '20px' }}>⬇️</span> Descargar la foto <small style={{ fontWeight: 400, color: '#6B7280' }}>(para Instagram)</small></button>
          <button style={opcion} onClick={copiar}><span style={{ fontSize: '20px' }}>🔗</span> Copiar texto y enlace</button>
        </div>
      </div>
    </div>
  );
}
